import PropTypes from 'prop-types';

import { CurrentNetworkProvider } from 'hb-react/frontoffice/contexts/DefaultAppContexts';
import PageCustomizableContainer from 'hb-react/shared/apps/PageCustomizables/containers/PageCustomizableContainer';

const PageCustomizableStandalone = ({ network, ...props }) => (
  <CurrentNetworkProvider currentNetwork={network}>
    <PageCustomizableContainer app="publicoffice" {...props} />
  </CurrentNetworkProvider>
);

PageCustomizableStandalone.propTypes = {
  network: PropTypes.object.isRequired,
};

export default PageCustomizableStandalone;
